var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"n"}},_vm._l((5),function(i){return _c('canvas',{key:i,ref:"c",refInFor:true})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }